import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Visual-only title case for display (does not mutate data)
// Handles spaces, hyphens and apostrophes naïvely but predictably.
export function titleCase(input: string): string {
  if (!input) return input
  const lower = input.toLowerCase()
  const cap = (s: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s)
  return lower
    .split(" ")
    .map((word) => word.split("-").map((p) => p.split("'").map(cap).join("'")).join("-"))
    .join(" ")
}
